import { ExclamationTriangleIcon } from '@/components/Icons'
import { useUiStrings } from '@/hooks/useUiStrings'
import type { ConflictWarningCard } from './assist.types'

type AssistConflictWarningCardProps = {
  card: ConflictWarningCard
}

export default function AssistConflictWarningCard({ card }: AssistConflictWarningCardProps) {
  const { t } = useUiStrings()

  return (
    <div
      className="rounded-lg border border-amber-400/50 bg-amber-50 p-2.5 text-xs dark:border-amber-500/40 dark:bg-amber-500/10"
      data-testid={`copilot-conflict-${card.issueKey}`}
    >
      <p className="flex items-center gap-1 font-semibold text-amber-800 dark:text-amber-300">
        <ExclamationTriangleIcon className="h-3.5 w-3.5 shrink-0" />
        {card.issueKey}
      </p>
      <p className="mt-1 text-slate-800 dark:text-[var(--text-primary)]">
        {t.assistConflictInMeeting}: {card.inMeeting}
      </p>
      <p className="text-slate-800 dark:text-[var(--text-primary)]">
        {t.assistConflictInBacklog}: {card.inBacklog}
      </p>
      <a
        href={card.link}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-1 inline-block text-blue-600 hover:underline dark:text-[var(--accent)]"
      >
        {t.assistTicketLink}
      </a>
    </div>
  )
}
